module.exports = __webpack_public_path__ + "images/6cb875f395f674c69b5fc344255351ae.svg";